import { propOr } from 'ramda'
import { CONFIG } from '../configuration'

// AppTheme uses getters to access CONFIG directly
export const AppTheme = {
  get customer() {
    return CONFIG.CUSTOMER
  },
  get logoUrl() {
    return CONFIG.LOGO
  },
  get appTitle() {
    return CONFIG.TITLE
  },
  get primaryColorHex() {
    return CONFIG.PRIMARY_COLOR_HEX
  },
  get primaryColorRgb() {
    return CONFIG.PRIMARY_COLOR_RGB
  },
  get secondaryColorHex() {
    return CONFIG.SECONDARY_COLOR_HEX
  },
  get secondaryColorRgb() {
    return CONFIG.SECONDARY_COLOR_RGB
  },
  get dangerColorHex() {
    return CONFIG.DANGER_COLOR_HEX
  },
  get dangerColorRgb() {
    return CONFIG.DANGER_COLOR_RGB
  },
}

/**
 * Initializes the Ionic theme CSS variables.
 * Must be called after initializeConfigCache().
 */
export function initializeTheme(): void {
  // Update Ionic CSS variables
  const CssTheme = {
    '--ion-color-primary': AppTheme.primaryColorHex,
    '--ion-color-primary-rgb': AppTheme.primaryColorRgb,
    '--ion-color-secondary': AppTheme.secondaryColorHex,
    '--ion-color-secondary-rgb': AppTheme.secondaryColorRgb,
    '--ion-color-danger': AppTheme.dangerColorHex,
    '--ion-color-danger-rgb': AppTheme.dangerColorRgb,
  }

  const style = document.documentElement.style
  Object.keys(CssTheme).forEach((key) => {
    style.setProperty(key, propOr('', key, CssTheme))
  })
}
